import type { components } from './schema'

/** Every view model comes from the generated OpenAPI types - no hand-written shapes. */
export type Schemas = components['schemas']

export type DocumentOut = Schemas['DocumentOut']
export type DocumentDetail = Schemas['DocumentDetail']
export type DocumentPage = Schemas['DocumentPage']
export type CaseOut = Schemas['CaseOut']
export type CaseDetail = Schemas['CaseDetail']
export type CasePage = Schemas['CasePage']
export type ReminderOut = Schemas['ReminderOut']
export type SearchResponseOut = Schemas['SearchResponseOut']
/** The server emits Input/Output variants because ParsedQuery travels in both directions. */
export type ParsedQuery = Schemas['ParsedQuery-Output']
export type ParsedQueryInput = Schemas['ParsedQuery-Input']
export type SystemStatus = Schemas['SystemStatus']
export type MailAccountOut = Schemas['MailAccountOut']
export type FolderOut = Schemas['FolderOut']
export type LLMProviderOut = Schemas['LLMProviderOut']
export type ProviderTestOut = Schemas['ProviderTestOut']
export type ConnectionTestOut = Schemas['ConnectionTestOut']
export type LmLinkOut = Schemas['LmLinkOut']
export type ClaudeStatusOut = Schemas['ClaudeStatusOut']
export type CategoryOut = Schemas['CategoryOut']
export type DeviceOut = Schemas['DeviceOut']
export type UserOut = Schemas['UserOut']
export type JobOut = Schemas['JobOut']
export type PartyOut = Schemas['PartyOut']
export type TierStatus = Schemas['TierStatus']

export type SearchGroup = {
  case_id: string | null
  title: string
  score: number
  status?: string | null
  documents: SearchHit[]
}

export type SearchHit = {
  id: string
  title: string
  summary: string
  doc_type: string | null
  source: string
  document_date: string | null
  due_date: string | null
  amount_total: number | null
  currency: string | null
  party: string | null
  score: number
  matched_by: string[]
  highlight: string
}

export const DOC_TYPES = [
  'Rechnung',
  'Mahnung',
  'Bestellbestätigung',
  'Versand',
  'Erstattung',
  'Vertrag',
  'Kündigung',
  'Behörde',
  'Versicherung',
  'Bank',
  'Gehalt',
  'Termin',
  'Newsletter',
  'Persönlich',
  'Sonstiges',
] as const

export const TIER_LABELS: Record<string, string> = {
  always: 'Immer (CPU)',
  batch: 'Batch (Ollama)',
  heavy: 'Schwer (LM Link)',
  cloud: 'Cloud (Claude CLI)',
  client: 'Gerät',
}

export const SOURCE_LABELS: Record<string, string> = {
  mail: 'E-Mail',
  letter: 'Brief',
  attachment: 'Anhang',
}
